import cn from 'classnames';
import { useEffect } from 'react';
import { withBaseErrorBoundary } from '@components/error-boundaries';
import { setWidgetIframeHeight } from '@utils/parant-site-comunicator';
import { SignInBody } from './sign-in-body';
import { SignInFooter } from './sign-in-footer';
import { signInId } from '../helpers';

import styles from '../auth-page.module.scss';

export const SignInPage = withBaseErrorBoundary(() => {
    useEffect(() => {
        setTimeout(() => {
            setWidgetIframeHeight('default');
        }, 500);
    });

    return (
        <div id={signInId('page')} className={styles.layout}>
            <div className="container">
                <div className={cn('rounded-box', styles.box)}>
                    <SignInBody />
                    <SignInFooter type="page" />
                </div>
            </div>
        </div>
    );
});
